import { Injectable } from '@angular/core';
import { CONFIG } from '../../shared/config';
import { MessageService, HttpGeneralService } from '../../shared/shared';

let favoritesUrl = CONFIG.baseUrls.favorites;

export interface Favorite {
    secLoginId: number,
    serial: number,
    linkId: number,
    sortView: number,
    dataStatus: number;
}


@Injectable()
export class FavoriteService {
    constructor(private httpGeneralService: HttpGeneralService,
        private _messageService: MessageService) {
        this._messageService.state.subscribe(state => this.getFavorites());
    }


    getFavorites() {
        return this.httpGeneralService.getWith(`${favoritesUrl}`)
    }

    UpdateFavorites(data: Favorite) {
        return this.httpGeneralService.update(data.serial, data, `${favoritesUrl}/Favourite`)
    }

    addFavorite(favorite: Favorite) {
        favorite.serial = favorite.serial || -1;
        return this.httpGeneralService.add<Favorite>(favorite, favoritesUrl)
    }

    getFavorite(favorite: Favorite, secLoginId: number, linkId: number) {
        return this.httpGeneralService.getWith(`${favoritesUrl}/Favourite/${secLoginId}/${linkId}`)
    }

    deleteFavorite(favorite: Favorite) {
        return this.httpGeneralService.delete<number>(favorite.serial, `${favoritesUrl}`)
    }

    addMultiFavoritelinks(rows: Favorite[]) {
        return this.httpGeneralService.addCollection<Favorite>(rows, `${favoritesUrl}/AddUpdateMulti`)
    }

}
